export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-ease/src/linear.js
// module id = ../../../../d3-ease/src/linear.js
// module chunks = 3